<template>
  <div class="block">
    <el-cascader
      ref="cascader"
      v-model="valueMulty"
      :class="test"
      :options="options"
      :show-all-levels="false"
      @change="handleChange"
      placeholder="小区"
    ></el-cascader>
  </div>
</template>

<script>
import { getDistrictFilter } from '~/api/community.api'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      test: 'a',
      valueMulty: [],
      options: [],
      nameMap: new Map()
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.handleChange(newVal)
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    clear() {},

    async initData() {
      const res = await getDistrictFilter({
        companyId: this.$route.params.companyId
      })
      const vm = this
      const map = res.map((item) => {
        let children = null
        if (item.communityList) {
          children = item.communityList.map((item) => {
            vm.nameMap.set(item.communityName, item.communityId)
            return {
              value: item.communityName,
              label: item.communityName
            }
          })
        }

        const obj = {
          value: item.district,
          label: item.district,
          children
        }
        return obj
      })
      map.unshift({ value: '', label: '全部' })
      this.options = map
    },
    handleChange(value) {
      if (this.valueMulty[0] === '') {
        this.valueMulty = []
        this.$emit('change-list', 'multy', '', '')
        return
      }
      this.valueMulty = value
      const communityId = this.nameMap.get(this.valueMulty[1])
      this.$emit('change-list', 'multy', this.valueMulty[1], communityId)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-cascader-menu__wrap {
  height: 280px !important;
}
:deep(.el-input input) {
  background: inherit;
  color: white;
}
@media screen and (max-width: 901px) {
  .el-cascader__dropdown {
    left: 2px !important;
    right: 2px !important;
    margin-top: 2px !important;
    .el-cascader-menu:last-child {
      border-right: none;
      width: 90% !important;
    }
    .el-cascader-menu:first-child {
      min-width: 120px !important;
      width: auto !important;
    }
    .popper__arrow {
      display: none !important;
    }
  }
}
</style>
